export default __webpack_public_path__ + "static/media/afternoon.f529dd3d.svg";